import { isMobileScreen } from '@apply/ui';

export interface BussinessNameCellProps {
    businessName: string | undefined;
}

export const BusinessNameCell: React.FC<BussinessNameCellProps> = ({ businessName }) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            {businessName && (
                <div className={`activatedBrokerReferralsTable-businessName ${mobileScreen ? 'mobile' : ''}`}>
                    <div className='activatedBrokerReferralsTable-businessName-value'>{businessName}</div>
                </div>
            )}
        </>
    );
};
